import { render } from "./dialog-message.component.vue?vue&type=template&id=39963738&scoped=true"
import script from "./dialog-message.component.vue?vue&type=script&lang=js"
export * from "./dialog-message.component.vue?vue&type=script&lang=js"

import "./dialog-message.component.vue?vue&type=style&index=0&id=39963738&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39963738"]])

export default __exports__